/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BundlesViewComponent} from './bundles-view.component';
import {PeriodBundlesTableModule} from '../period-bundles-table/period-bundles-table.module';
import {LoadingSpinnerModule} from '../../shared/loading/loading-spinner/loading-spinner.module';
import {PeriodTypeInfoChartModule} from '../shared/components/period-type-info-chart/period-type-info-chart.module';

@NgModule({
    declarations: [BundlesViewComponent],
    imports: [
        CommonModule,
        PeriodBundlesTableModule,
        LoadingSpinnerModule,
        PeriodTypeInfoChartModule
    ],
    exports: [BundlesViewComponent]
})
export class BundlesViewModule {
}
